var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 96,
    viewBox: "0 0 82 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4182 0.779907C14.6407 0.779907 1.84366 15.7677 1.31032 16.4062C1.09003 16.6737 0.969409 17.0082 0.96875 17.3535L0.96875 47.2104C0.96875 72.4644 24.4174 87.4581 34.4968 92.7322C34.8459 92.8925 35.2437 92.9138 35.6081 92.7918C35.9726 92.6698 36.2758 92.4138 36.4554 92.0766C36.6349 91.7394 36.677 91.3468 36.5729 90.9797C36.4688 90.6127 36.2266 90.2992 35.8961 90.1041C23.971 83.8649 3.965 69.9966 3.965 47.2075V17.9178C6.06838 15.6757 17.8437 4.26628 39.9201 3.76738V94.324C39.9199 94.6256 40.0124 94.9202 40.1854 95.1685C40.3583 95.4167 40.6034 95.6069 40.8881 95.7136C41.1728 95.8203 41.4835 95.8386 41.779 95.7659C42.0744 95.6933 42.3405 95.5332 42.5418 95.3069C47.4467 93.2163 81.8676 77.4445 81.8676 46.8095V17.113C81.8676 16.7671 81.7458 16.432 81.5231 16.1657C81.0796 15.6341 70.395 3.17345 48.1418 0.949177C47.7474 0.914107 47.3548 1.03335 47.048 1.28141C46.7412 1.52947 46.5444 1.88666 46.4998 2.27661C46.4799 2.47063 46.4988 2.66663 46.5554 2.85343C46.6119 3.04022 46.705 3.21414 46.8294 3.36526C46.9538 3.51638 47.107 3.64174 47.2802 3.73417C47.4535 3.82661 47.6434 3.88431 47.8392 3.90398C66.6766 5.78674 76.9118 15.6193 78.8714 17.6832V46.8095C78.8714 73.3939 50.8174 88.2332 42.9163 91.8859V2.26473C42.9163 1.87093 42.7585 1.49326 42.4775 1.2148C42.1966 0.936344 41.8155 0.779907 41.4182 0.779907Z",
    fill: "#151515"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.6705,
    cy: 45.7668,
    rx: 31.5455,
    ry: 31.3396,
    fill: "#9E007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleShield);
export default __webpack_public_path__ + "static/media/purple-shield.85a649be037f3dafec583220071a34d9.svg";
export { ForwardRef as ReactComponent };